'use strict';

import { newModalFromString } from '../components/modal';
import EmailDomainValidation from 'checkout/emailDomainValidation';
import { checkNewAddressForm } from './address';

var addressHelpers = require('./address');
var formHelpers = require('./formErrors');

/**
 * Show, if it is a valid value, the estimated shipping date for the current order
 */
function updateEstimatedArriveTime () {
    let checkedMethodEstimatedArriveDays = $('input[name="dwfrm_shipping_shippingAddress_shippingMethodID"]:checked').data('day');
    let $shippingDateDiv = $('#estimated-arrive');
    let $shippingDateSpan = $('#estimated-arrive-days');
    if (checkedMethodEstimatedArriveDays == null) {
        $shippingDateDiv.hide();
        $shippingDateSpan.text(checkedMethodEstimatedArriveDays);
    } else {
        $shippingDateDiv.show();
        $shippingDateSpan.text(checkedMethodEstimatedArriveDays);
    }
}

$(document).ready(updateEstimatedArriveTime);

/**
 * updates the shipping address selector within shipping forms
 * @param {Object} productLineItem - the productLineItem model
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order model
 * @param {Object} customer - the customer model
 */
function updateShippingAddressSelector (productLineItem, shipping, order, customer) {
    var uuidEl = $('input[value=' + productLineItem.UUID + ']');
    var shippings = order.shipping;

    var form;
    var $shippingAddressSelector;
    var hasSelectedAddress = false;

    if (uuidEl && uuidEl.length > 0) {
        form = uuidEl[0].form;
        $shippingAddressSelector = $('.addressSelector', form);
    }

    if ($shippingAddressSelector && $shippingAddressSelector.length === 1) {
        $shippingAddressSelector.empty();
        // Add New Address option
        $shippingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
            null,
            false,
            order));
        // Separator -
        $shippingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
            order.resources.shippingAddresses, false, order, { className: 'multi-shipping' }
        ));
        shippings.forEach(function (aShipping) {
            var isSelected = shipping.UUID === aShipping.UUID;
            hasSelectedAddress = hasSelectedAddress || isSelected;
            $shippingAddressSelector.append(
                addressHelpers.methods.optionValueForAddress(aShipping, isSelected, order,
                    { className: 'multi-shipping' }
                )
            );
        });
        if (customer.addresses && customer.addresses.length > 0) {
            $shippingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
                order.resources.accountAddresses, false, order));
            customer.addresses.forEach(function (address) {
                var isSelected = shipping.matchingAddressId === address.ID;
                $shippingAddressSelector.append(
                    addressHelpers.methods.optionValueForAddress({
                        UUID: 'ab_' + address.ID,
                        shippingAddress: address
                    }, isSelected, order)
                );
            });
        }
    }

    if (!hasSelectedAddress) {
        // show
        $(form).addClass('hide-details');
    } else {
        $(form).removeClass('hide-details');
    }

    $('body').trigger('shipping:updateShippingAddressSelector', {
        productLineItem: productLineItem,
        shipping: shipping,
        order: order,
        customer: customer
    });
}

/**
 * updates the shipping address form values within shipping forms
 * @param {Object} shipping - the shipping (shipment model) model
 */
function updateShippingAddressFormValues (shipping, customer, address) {
    var addressObject = $.extend({}, shipping.shippingAddress);

    if (!addressObject) {
        addressObject = {
            firstName: null,
            lastName: null,
            address1: null,
            address2: null,
            city: null,
            postalCode: null,
            stateCode: null,
            countryCode: null,
            phone: null,
            addressId: null
        };
    }

    addressObject.isGift = shipping.isGift;
    addressObject.giftMessage = shipping.giftMessage;

    $('input[value=' + shipping.UUID + ']').each(function (formIndex, el) {
        var form = el.form;
        if (!form) return;
        var countryCode = addressObject.countryCode;

        $('input[name$=_addressId]', form).val(addressObject.addressId || shipping.matchingAddressId);
        $('input[name$=_firstName]', form).val(addressObject.firstName || (customer && 'profile' in customer && customer.profile && 'firstName' in customer.profile ? customer.profile.firstName || '' : ''));
        $('input[name$=_lastName]', form).val(addressObject.lastName || (customer && 'profile' in customer && customer.profile && 'lastName' in customer.profile ? customer.profile.lastName || '' : ''));
        $('input[name$=_address1]', form).val(addressObject.address1);
        $('input[name$=_address2]', form).val(addressObject.address2);
        $('input[name$=_city]', form).val(addressObject.city);
        $('input[name$=_postalCode]', form).val(addressObject.postalCode);
        $('select[name$=_stateCode],input[name$=_stateCode]', form)
            .val(addressObject.stateCode);

        if (countryCode && typeof countryCode === 'object') {
            $('select[name$=_country]', form).val(addressObject.countryCode.value);
        } else {
            if (address) {
                $('select[name$=_country]', form).val(address.countryCode);
            }
        }

        $('input[name$=_isGift]', form).prop('checked', addressObject.isGift);
        $('textarea[name$=_giftMessage]', form).val(addressObject.isGift && addressObject.giftMessage ? addressObject.giftMessage : '');
    });

    $('body').trigger('shipping:updateShippingAddressFormValues', { shipping: shipping });
}

/**
 * update the list of states and postal code regex in shipping address
 * @param {Object} data
 * @param {Object[]} statesOptions the new list of states
 * @param {String} postalCodeRegex new postalCode regex
 */
function updateShippingStatesAndPostalCode (data) {
    $('#shippingState').find('option').remove();
    var stateOptions = '';
    data.statesOptions.forEach(state => {
        stateOptions += `<option id="${state.id}" value="${state.value}">${state.label}</option>`;
    });
    $('#shippingState').append(stateOptions);
    $('#shippingState').trigger('chosen:updated');
    $('#shippingZipCode').prop('pattern', data.postalCodeRegex);
}

/**
 * updates the shipping method radio buttons within shipping forms
 * @param {Object} shipping - the shipping (shipment model) model
 */
function updateShippingMethods (shipping) {
}

/**
 * Update list of available shipping methods whenever user modifies shipping address details.
 * @param {jQuery} $shippingForm - current shipping form
 */
function updateShippingMethodList ($shippingForm) {
    // delay for autocomplete!
    setTimeout(function () {
        var $shippingMethodList = $shippingForm.find('.shipping-method-list');
        var urlParams = addressHelpers.methods.getAddressFieldsFromUI($shippingForm);
        var shipmentUUID = $shippingForm.find('[name=shipmentUUID]').val();
        var url = $shippingMethodList.data('actionUrl');
        urlParams.shipmentUUID = shipmentUUID;

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('body').trigger('checkout:updateCheckoutView',
                        {
                            order: data.order,
                            customer: data.customer,
                            options: { keepOpen: true }
                        });

                    $shippingMethodList.spinner().stop();
                }
            }
        });
    }, 300);
}

/**
 * updates the order shipping summary for an order shipment model
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order model
 */
function updateShippingSummaryInformation (shipping, order) {
    $('[data-shipment-summary=' + shipping.UUID + ']').each(function (i, el) {
        var $container = $(el);
        var $shippingAddressLabel = $container.find('.shipping-addr-label');
        var $addressContainer = $container.find('.address-summary');
        var $shippingPhone = $container.find('.shipping-phone');
        var $shippingEmail = $container.find('.shipping-email');
        var $methodTitle = $container.find('.js-shipping-method-summary-title');
        var $methodAnalytics = $container.find('.js-shipping-method-summary-type');
        var $methodArrivalTime = $container.find('.js-shipping-method-summary-days');
        var $methodPrice = $container.find('.shipping-method-price');
        var $shippingSummaryLabel = $container.find('.shipping-method-label');
        var $summaryDetails = $container.find('.row.summary-details');
        var giftMessageSummary = $container.find('.gift-summary');
        var $storeName = $container.find('.address-summary-store-name');

        var address = shipping.shippingAddress;
        var selectedShippingMethod = shipping.selectedShippingMethod;
        var isGift = shipping.isGift;
        var isBopis = $('.store-info').hasClass('is-bopis');
        var isSpliced = $('#checkout-main').attr('data-isspliced') === 'true' || $('.spliced').length > 0;
        var dispoArrivalLabel = $('.shipping-method-selected .estimated-delivery').text() !== '' ? $('.shipping-method-selected .estimated-delivery').text() : $('.checkout-guest-shipping-delivery').text();

        if ($('.shipping-method-selected  input[data-pickup="true"]').parent().find('.dispoArrivalInterval').length > 0) {
            $('.shipping-method-selected .estimated-delivery').text($('.dispoArrivalInterval').val());
        } else if ($('.shipping-method-selected  input[data-pickup="true"]').parent().find('.noDispoArrivalInterval').length > 0) {
            $('.shipping-method-selected .estimated-delivery').text($('.noDispoArrivalInterval').val());
        }
        
        if (selectedShippingMethod) {
            if ('pointPickupEnabled' in selectedShippingMethod && selectedShippingMethod.pointPickupEnabled) {
                // The selected shipping method is pickup point
            } else if (address) {
                // The selected shipping method is not pickup point
                // We can clear the pickUpPointName node in address
                address.pickUpPointName = null;
            }
        }

        addressHelpers.methods.populateAddressSummary($addressContainer, address);

        if (address && address.phone) {
            $shippingPhone.text(address.phone);
        } else {
            $shippingPhone.empty();
        }
        if (order && order.orderEmail) {
            $shippingEmail.text(order.orderEmail);
        } else {
            $shippingEmail.empty();
        }

        if (selectedShippingMethod) {
            $('body').trigger('shipping:updateAddressLabelText',
                { selectedShippingMethod: selectedShippingMethod, resources: order.resources, shippingAddressLabel: $shippingAddressLabel });
            $shippingAddressLabel.text(order.resources.shippingAddress);
            $shippingSummaryLabel.show();
            $summaryDetails.show();
            if (isBopis) {
                $methodTitle.text(selectedShippingMethod.shippingMethodRecapTitle);
            } else if (isSpliced) {
                $methodTitle.text(selectedShippingMethod.shippingMethodRecapTitle);
            } else if (selectedShippingMethod.estimatedArriveDaysInterval && $('#isDispoCountry').val() === 'false') {
                $methodTitle.text(selectedShippingMethod.shippingMethodRecapTitle + ' ' + selectedShippingMethod.estimatedArriveDaysInterval);
            } else {
                $methodTitle.text(selectedShippingMethod.shippingMethodRecapTitle);
            }
            if (isBopis) {
                $methodArrivalTime.text(dispoArrivalLabel);
            } else if (selectedShippingMethod.estimatedArriveDays) {
                $methodArrivalTime.text(selectedShippingMethod.estimatedArriveDays);
            } else {
                $methodArrivalTime.text('');
            }
            var shippingName = 'home_standard';
            $storeName.text('').hide();
            if (selectedShippingMethod.storePickupEnabled) {
                $container.find('.address-summary-courier').hide();
                $container.find('.address-summary-other').show();
                shippingName = 'shop';
                // Fill store name on order summary with selected store name
                $storeName.text($('.shipping-section .js-store-name').text()).show();
            } else if (selectedShippingMethod.pointPickupEnabled) {
                $container.find('.address-summary-courier').hide();
                $container.find('.address-summary-other').show();
                shippingName = 'pickup_point';
            } else {
                if (selectedShippingMethod.isExpressShipping) {
                    shippingName = 'home_express';
                }
                $container.find('.address-summary-courier').show();
                $container.find('.address-summary-other').hide();
            }
            $methodAnalytics.text(shippingName);

            updateEstimatedArriveTime();
        }

        if (isGift) {
            giftMessageSummary.find('.gift-message-summary').text(shipping.giftMessage);
            giftMessageSummary.removeClass('d-none');
        } else {
            giftMessageSummary.addClass('d-none');
        }
    });

    $('body').trigger('shipping:updateShippingSummaryInformation', { shipping: shipping, order: order });
}

/**
 * Update the read-only portion of the shipment display (per PLI)
 * @param {Object} productLineItem - the productLineItem model
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order model
 * @param {Object} [options] - options for updating PLI summary info
 * @param {Object} [options.keepOpen] - if true, prevent changing PLI view mode to 'view'
 */
function updatePLIShippingSummaryInformation (productLineItem, shipping, order, options) {
    var keepOpen = options && options.keepOpen;

    var $pli = $('input[value=' + productLineItem.UUID + ']');
    var form = $pli && $pli.length > 0 ? $pli[0].form : null;

    if (!form) return;

    var $viewBlock = $('.view-address-block', form);

    var hasAddress = !!shipping.shippingAddress;
    var address = shipping.shippingAddress || {};
    var selectedMethod = shipping.selectedShippingMethod;

    var nameLine = address.firstName ? address.firstName + ' ' : '';
    if (address.lastName) nameLine += address.lastName;

    var address1Line = address.address1;
    var address2Line = address.address2;

    var phoneLine = address.phone;

    var shippingCost = selectedMethod ? selectedMethod.shippingCost : '';
    var methodNameLine = selectedMethod ? selectedMethod.displayName : '';
    var methodArrivalTime = selectedMethod && selectedMethod.estimatedArrivalTime
        ? '(' + selectedMethod.estimatedArrivalTime + ')'
        : '';

    var tmpl = $('#pli-shipping-summary-template').clone();

    $('.ship-to-name', tmpl).text(nameLine);
    $('.ship-to-address1', tmpl).text(address1Line);
    $('.ship-to-address2', tmpl).text(address2Line);
    $('.ship-to-city', tmpl).text(address.city);
    if (address.stateCode) {
        $('.ship-to-st', tmpl).text(address.stateCode);
    }
    $('.ship-to-zip', tmpl).text(address.postalCode);
    $('.ship-to-phone', tmpl).text(phoneLine);

    if (!address2Line) {
        $('.ship-to-address2', tmpl).hide();
    }

    if (!phoneLine) {
        $('.ship-to-phone', tmpl).hide();
    }

    if (shipping.selectedShippingMethod) {
        $('.display-name', tmpl).text(methodNameLine);
        $('.arrival-time', tmpl).text(methodArrivalTime);
        $('.price', tmpl).text(shippingCost);
    }

    if (shipping.isGift) {
        $('.gift-message-summary', tmpl).text(shipping.giftMessage);
        var shipment = $('.gift-message-' + shipping.UUID);
        $(shipment).val(shipping.giftMessage);
    } else {
        $('.gift-summary', tmpl).addClass('d-none');
    }
    // checking h5 title shipping to or pickup
    var $shippingAddressLabel = $('.shipping-header-text', tmpl);
    $('body').trigger('shipping:updateAddressLabelText',
        { selectedShippingMethod: selectedMethod, resources: order.resources, shippingAddressLabel: $shippingAddressLabel });

    $viewBlock.html(tmpl.html());

    $('body').trigger('shipping:updatePLIShippingSummaryInformation', {
        productLineItem: productLineItem,
        shipping: shipping,
        order: order,
        options: options
    });
    if (!keepOpen) {
        if (hasAddress) {
            $viewBlock.parents('[data-view-mode]').attr('data-view-mode', 'view');
        } else {
            $viewBlock.parents('[data-view-mode]').attr('data-view-mode', 'enter');
        }
    }
}

/**
 * Update the hidden form values that associate shipping info with product line items
 * @param {Object} productLineItem - the productLineItem model
 * @param {Object} shipping - the shipping (shipment model) model
 */
function updateProductLineItemShipmentUUIDs (productLineItem, shipping) {
    $('input[value=' + productLineItem.UUID + ']').each(function (key, pli) {
        var form = pli.form;
        $('[name=shipmentUUID]', form).val(shipping.UUID);
        $('[name=originalShipmentUUID]', form).val(shipping.UUID);

        $(form).closest('.card').attr('data-shipment-uuid', shipping.UUID);
    });

    // updates the hidden field with a selected shipping type
    $('.shipping-method-type').text((shipping.selectedShippingMethod.storePickupEnabled) ? 'shop' : shipping.selectedShippingMethod.pointPickupEnabled ? 'pickup_point' : shipping.selectedShippingMethod.isExpressShipping ? 'home_express' : 'home_standard');

    $('body').trigger('shipping:updateProductLineItemShipmentUUIDs', {
        productLineItem: productLineItem,
        shipping: shipping
    });
}

/**
 * Update the shipping UI for a single shipping info (shipment model)
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order/basket model
 * @param {Object} customer - the customer model
 * @param {Object} [options] - options for updating PLI summary info
 * @param {Object} [options.keepOpen] - if true, prevent changing PLI view mode to 'view'
 */
function updateShippingInformation (shipping, order, customer, options, address) {
    // First copy over shipmentUUIDs from response, to each PLI form
    order.shipping.forEach(function (aShipping) {
        aShipping.productLineItems.items.forEach(function (productLineItem) {
            updateProductLineItemShipmentUUIDs(productLineItem, aShipping);
        });
    });

    // Now update shipping information, based on those associations
    // updateShippingMethods(shipping);
    updateShippingAddressFormValues(shipping, customer, address);
    updateShippingSummaryInformation(shipping, order);

    // And update the PLI-based summary information as well
    shipping.productLineItems.items.forEach(function (productLineItem) {
        updateShippingAddressSelector(productLineItem, shipping, order, customer);
        updatePLIShippingSummaryInformation(productLineItem, shipping, order, options);
    });

    $('body').trigger('shipping:updateShippingInformation', {
        order: order,
        shipping: shipping,
        customer: customer,
        options: options
    });
}

/**
 * Update the checkout state (single vs. multi-ship) via Session.privacy cache
 * @param {Object} order - checkout model to use as basis of new truth
 */
function updateMultiShipInformation (order) {
    var $checkoutMain = $('#checkout-main');
    var $checkbox = $('[name=usingMultiShipping]');
    var $submitShippingBtn = $('button.submit-shipping');

    if (order.usingMultiShipping) {
        // shippingState.changeState({ multiship: order.usingMultiShipping, collapsed: true });
        $checkoutMain.addClass('multi-ship');
        $checkbox.prop('checked', true);
    } else {
        $checkoutMain.removeClass('multi-ship');
        $checkbox.prop('checked', null);
        $submitShippingBtn.prop('disabled', null);
        // shippingState.changeState({ collapsed: true });
    }
}

/**
 * Handle response from the server for valid or invalid form fields.
 * @param {Object} defer - the deferred object which will resolve on success or reject.
 * @param {Object} data - the response data with the invalid form fields or
 *  valid model data.
 */
function shippingFormResponse (defer, data) {
    var isMultiShip = $('#checkout-main').hasClass('multi-ship');
    var formSelector = isMultiShip
        ? '.multi-shipping .active form'
        : '.single-shipping form';

    // highlight fields with errors
    if (data.error) {
        if (data.fieldErrors.length) {
            data.fieldErrors.forEach(function (error) {
                if (Object.keys(error).length) {
                    formHelpers.loadFormErrors(formSelector, error);
                }
            });
            defer.reject(data);
        }

        if (data.cartError) {
            window.location.href = data.redirectUrl;
            defer.reject();
        }
    } else {
        //
        // Populate the Address Summary
        //
        let error = false;
        if (data && data.order && data.order.shipping && data.order.shipping[0] && data.order.shipping[0].selectedShippingMethod) {
            let selectedShippingMethod = data.order.shipping[0].selectedShippingMethod;
            if ((selectedShippingMethod.shippingType && selectedShippingMethod.shippingType.value === 'pickupInPost') ||
                (selectedShippingMethod.shippingMethodType && (selectedShippingMethod.shippingMethodType === 'DPDPUP' || selectedShippingMethod.shippingMethodType === 'DHLLocationPUP' || selectedShippingMethod.shippingMethodType === 'PPLPUP' || selectedShippingMethod.shippingMethodType === 'CLSS'))) {
                if ((!data.pickUpPointName)) {
                    error = true;
                }
            }
        }
        if (!error) {
            $('body').trigger('checkout:updateCheckoutView',
                { order: data.order, customer: data.customer }
            );

            defer.resolve(data);
        } else {
            defer.reject();
        }
    }
}

/**
 * Does Ajax call to trigger multishipping
 * @param {boolean} checked - is multi shipping checked
 */
function toggleMultiShip (checked) {
    var url = $('.shipping-nav form').attr('action');
    $.spinner().start();
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: {
            usingMultiShip: !!checked
        },
        success: function (data) {
            if (data.error) {
                window.location.href = data.redirectUrl;
            } else {
                $('body').trigger('checkout:updateCheckoutView',
                    { order: data.order, customer: data.customer });
            }
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Does Ajax call to create a server-side shipment w/ pliUUID & URL
 * @param {string} url - string representation of endpoint URL
 * @param {Object} shipmentData - product line item UUID
 * @returns {Object} - promise value for async call
 */
function createNewShipment (url, shipmentData) {
    $.spinner().start();
    return $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: shipmentData
    });
}

/**
 * Hide/Show form based on selected shipping method
 * @param {Object} shipping - shipping object with custom attribute (pup and store pickup)
 */
function shippingSelectionResponse (data) {
    var shipping = data.shipping;
    $('.next-step-button').find('.submit-shipping').prop('disabled', false);
    $('.js-expressButtonContinue').prop('disabled', false);
    $('#expressButtonModal').attr('data-modal-stage', 'shipping');
    if (shipping.storePickupEnabled) {
        hideAddressForm('pickup');
        setMandatoryBilling();
    } else if (shipping.pointPickupEnabled) {
        hideAddressForm('pup');
        setMandatoryBilling();
    } else if (shipping.isElectronicShipping) {
        hideAddressFormForGiftcard();
        setMandatoryBilling();
    } else {
        showAddressForm();
        resetBillingState();
        checkNewAddressForm();
    }
}

/**
 * Does Ajax call to select shipping method
 * @param {string} url - string representation of endpoint URL
 * @param {Object} urlParams - url params
 */
function selectShippingMethodAjax (url, urlParams, el) {
    $.spinner().start();
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: urlParams
    })
        .done(function (data) {
            if (data.error) {
                window.location.href = data.redirectUrl;
            } else {
                if (data.shouldUpdateShippingFormValidation) {
                    updateShippingStatesAndPostalCode(data.newShippingFormData);
                }
                $('body').trigger('checkout:updateCheckoutView',
                    {
                        order: data.order,
                        customer: data.customer,
                        action: data.action,
                        options: {
                            keepOpen: true,
                            selectMethodStep: true
                        },
                        urlParams: urlParams
                    }
                );
                $('body').trigger('checkout:postUpdateCheckoutView',
                    {
                        el: undefined
                    }
                );
            }
            $.spinner().stop();
        })
        .fail(function () {
            $.spinner().stop();
        });
}

function clearInputFields () {
    const shippingForm = $('#shippingAddressForm .shipping-address-block');
    $('input[name$=_address1]', shippingForm).val('');
    $('input[name$=_houseNumber]', shippingForm).val('');
    $('input[name$=_address2]', shippingForm).val('');
    $('input[name$=_city]', shippingForm).val('');
    $('input[name$=_postalCode]', shippingForm).val('');
    const billingForm = $('.billingFormGroup');
    if (billingForm) {
        $('input[name$=_address1]', billingForm).val('');
        $('input[name$=_address2]', billingForm).val('');
        $('input[name$=_city]', billingForm).val('');
        $('input[name$=_postalCode]', billingForm).val('');
    }
}

function hideAddressFormForGiftcard () {
    $('input[name$=storeId]').remove();
    $('.shipment-selector-block').hide();
    const form = $('#shippingAddressForm .shipping-address-block');
    // $('input[name$=_firstName]', form).val('');
    // $('input[name$=_lastName]', form).val('');
    $('input[name$=_address1]', form).hide();
    $('input[name$=_houseNumber]', form).hide();
    $('input[name$=_address2]', form).hide();
    $('input[name$=_city]', form).hide();
    $('input[name$=_postalCode]', form).hide();
    $('select[name$=_stateCode],input[name$=_stateCode]', form).hide();
    $('label[for=shippingAddressOne]', form).hide();
    $('label[for=shippingAddressTwo]', form).hide();
    $('label[for=shippingAddressCity]', form).hide();
    $('label[for=shippingZipCode]', form).hide();
    $('label[for=shippingState]', form).hide();
    $('label[for=shippingCountry]', form).hide();

    // For UA
    $('input[name$=_flatNumber]', form).hide();
    $('input[name$=_orderNotes]', form).hide();
    $('.info-tooltip-address1', form).closest('.info-icon').hide();

    // Hide the fake dropdown
    $('.chosen-container', form).hide();
    $('.js-state-info-icon', form).hide();

    $('select[name$=_country]', form).hide();
    // $('input[name$=_phone]', form).val('');
    $('.shipping-address-subtitle', form).hide();
    $('.shipping-address-subtitle-electronic', form).show();
}

function hideAddressForm (typeMethod) {
    if (typeMethod !== 'pickup') {
        $('input[name$=storeId]').remove();
        $('.js-select-store').show();
        $('.shipping-form .js-change-store').hide();
        $('.selectedStoreRecap').hide();
    }

    if (typeMethod !== 'pup') {
        // Remove previous selection for pickup point
        $('input[name$=pickUpPointNumber]').remove();
        $('input[name$=pickUpPointName]').remove();
        $('input[name$=pickUpPointAddress1]').remove();
        $('input[name$=pickUpPointCity]').remove();
        $('input[name$=pickUpPointPostalCode]').remove();
        $('.js-select-pickup-recap').addClass('hide');
        $('.selectedPickupPointRecap').hide();
        $('.js-select-pickup-btn').removeClass('hide');
        $('.js-select-point').show();
    }

    $('.shipment-selector-block').hide();
    const form = $('#shippingAddressForm .shipping-address-block');
    $('input[name$=_addressId]', form).val('');
    $('input[name$=_address1]', form).hide();
    $('input[name$=_houseNumber]', form).hide();
    $('input[name$=_address2]', form).hide();
    $('input[name$=_city]', form).hide();
    $('select[name$=_city]').eq(0).hide(); // For TR
    $('input[name$=_postalCode]', form).hide();
    $('select[name$=_stateCode],input[name$=_stateCode],select[name$=_city]', form).hide();
    $('label[for=shippingAddressOne]', form).hide();
    $('label[for=shippingAddressTwo]', form).hide();
    $('label[for=shippingAddressCity]', form).hide();
    $('label[for=shippingZipCode]', form).hide();
    $('label[for=shippingState]', form).hide();
    $('label[for=shippingCountry]', form).hide();

    // For UA
    $('input[name$=_flatNumber]', form).hide();
    $('input[name$=_orderNotes]', form).hide();
    $('.info-tooltip-address1', form).closest('.info-icon').hide();

    $('.chosen-container', form).hide();
    $('.js-state-info-icon', form).hide();

    $('select[name$=_country]', form).hide();
    if (typeMethod === 'electronic') {
        $('.shipping-address-subtitle', form).hide();
        $('.shipping-address-subtitle-electronic', form).show();
    } else if (typeMethod === 'pup') {
        $('.shipping-address-subtitle', form).hide();
        $('.shipping-address-subtitle-pup', form).show();
    } else {
        $('.shipping-address-subtitle', form).hide();
        $('.shipping-address-subtitle-pickup', form).show();
    }

    var currentCountry = $('#country-code').val();
    if (currentCountry !== 'RU' && currentCountry !== 'AE') {
        var contactFormContainer = $('.shipping-contact-container');
        var containerForPickup = $('.shipping-contact-container-pickup');
        contactFormContainer.children().appendTo(containerForPickup);
        $('.spacer-large-contact-pickup').removeClass('hidden');
    }
}

function showAddressForm () {
    const form = $('#shippingAddressForm .shipping-address-block');
    $('input[name$=_address1]', form).show();
    $('input[name$=_houseNumber]', form).show();
    $('input[name$=_address2]', form).show();
    $('input[name$=_city]', form).show();
    // $('select[name$=_city]').eq(0).show(); // For TR
    // $('select[name$=_stateCode]').eq(0).show(); // For TR
    $('input[name$=_postalCode]', form).show();
    $('label[for=shippingAddressOne]', form).show();
    $('label[for=shippingAddressTwo]', form).show();
    $('label[for=shippingAddressCity]', form).show();
    $('label[for=shippingZipCode]', form).show();
    $('label[for=shippingState]', form).show();
    $('label[for=shippingCountry]', form).show();
    $('.js-state-info-icon', form).show();
    if (!Foundation.MediaQuery.atLeast('medium')) {
        $('select[name$=_country]', form).show();
        $('select[name$=_city]', form).eq(0).show();
        $('select[name$=_stateCode]', form).eq(0).show();
    }
    $('.chosen-container', form).show();
    $('#shippingAddressForm').show();
    $('.shipment-selector-block').show();
    $('.selectedStoreRecap').hide();
    $('input[name$=storeId]').remove();

    // Remove previous selection for pickup point
    $('input[name$=pickUpPointNumber]').remove();
    $('input[name$=pickUpPointName]').remove();
    $('input[name$=pickUpPointAddress1]').remove();
    $('input[name$=pickUpPointCity]').remove();
    $('input[name$=pickUpPointPostalCode]').remove();
    $('.js-select-pickup-recap').addClass('hide');
    $('.selectedPickupPointRecap').hide();
    $('.js-select-pickup-btn').removeClass('hide');
    $('.js-select-point').show();

    $('#selectedStoreRecap').hide();
    $('.shipping-form .js-select-store').show();
    $('.shipping-form .js-change-store').hide();
    $('.express-flow-modal-custom .selectedStoreRecap').hide();

    // Control for pickup point elements
    $('#selectedPickupPointRecap').hide();
    $('.shipping-form .js-select-point').show();
    $('.shipping-form .js-change-point').hide();
    $('.express-flow-modal-custom .selectedPickupPointRecap').hide();
    $('.shipping-address-subtitle', form).hide();
    $('.shipping-address-subtitle-courier', form).show();

    // For UA
    $('input[name$=_flatNumber]', form).show();
    $('input[name$=_orderNotes]', form).show();
    $('.info-tooltip-address1', form).closest('.info-icon').show();

    $('#new-address:checked').trigger('change');

    var currentCountry = $('#country-code').val();
    if (currentCountry !== 'RU' && currentCountry !== 'AE') {
        var contactFormContainer = $('.shipping-contact-container');
        var containerForPickup = $('.shipping-contact-container-pickup');
        containerForPickup.children().appendTo(contactFormContainer);
        $('.spacer-large-contact-pickup').addClass('hidden');
    }
}

function setMandatoryBilling () {
    $('label[for="billInDifferentAddress"]').addClass('hide');
}

function resetBillingState () {
    $('label[for="billInDifferentAddress"]').removeClass('hide');
}

function enableExpressButton (shipment, data) {
    var expressMethodEnabled = true;
    if (data.order && data.order.items) {
        const orderItems = data.order.items.items;
        for (let item of orderItems) {
            if (!item.wrappedQuantity || item.wrappedQuantity === 0) {
                $('.js-gifting-container-' + item.UUID).hide();
            } else {
                expressMethodEnabled = false;
                $('.js-gifting-container-' + item.UUID).show();
                $('.js-wrapped-quantity-' + item.UUID).html(item.wrappedQuantity);
            }
            if (item.isGiftKit) {
                expressMethodEnabled = false;
            }
        }
    }
    if (expressMethodEnabled) {
        $('.js-paypal-container').removeClass('disabled');
        $('.js-amazon-pay-container').removeClass('disabled');
        $('.js-google-pay-container').removeClass('disabled');
        // if the shipping method selected is not the default courier, applePay button should be disabled
        if (shipment.selectedShippingMethod.isApplePayEnabled) {
            $('.js-apple-pay-container').removeClass('disabled');
        } else {
            $('.js-apple-pay-container').addClass('disabled');
        }
    } else {
        $('.js-paypal-container').addClass('disabled');
        $('.js-apple-pay-container').addClass('disabled');
        $('.js-amazon-pay-container').addClass('disabled');
        $('.js-google-pay-container').addClass('disabled');
    }
}

module.exports = {
    methods: {
        updateShippingAddressSelector: updateShippingAddressSelector,
        updateShippingAddressFormValues: updateShippingAddressFormValues,
        updateShippingMethods: updateShippingMethods,
        updateShippingSummaryInformation: updateShippingSummaryInformation,
        updatePLIShippingSummaryInformation: updatePLIShippingSummaryInformation,
        updateProductLineItemShipmentUUIDs: updateProductLineItemShipmentUUIDs,
        updateShippingInformation: updateShippingInformation,
        updateMultiShipInformation: updateMultiShipInformation,
        shippingFormResponse: shippingFormResponse,
        toggleMultiShip: toggleMultiShip,
        createNewShipment: createNewShipment,
        selectShippingMethodAjax: selectShippingMethodAjax,
        updateShippingMethodList: updateShippingMethodList,
        shippingSelectionResponse: shippingSelectionResponse,
        showAddressForm: showAddressForm,
        hideAddressForm: hideAddressForm,
        hideAddressFormForGiftcard: hideAddressFormForGiftcard,
        setMandatoryBilling: setMandatoryBilling,
        resetBillingState: resetBillingState,
        clearInputFields: clearInputFields
    },

    updateViewAfterChangeShippingMethod: function () {
        if ($('[data-pickup="true"]:checked').length || $('[data-pickup-point="true"]:checked').length || $('[data-iselectronic="true"]:checked').length) {
            setMandatoryBilling();
            if ($('[data-pickup="true"]:checked').length) {
                hideAddressForm('pickup');
            } else if ($('[data-pickup-point="true"]:checked').length) {
                hideAddressForm('pup');
            } else {
                hideAddressForm('electronic');
            }
        }

        $(document).on('shipping:updateShippingInformation', function (evt, data) {
            $('#shippingAddressForm').prepend($('.shipping-address-block'));
            $('.shipping-address-block').removeClass('hidden');
            const shipment = data.shipping;
            var stepShippingCompleted = $('.shipping-form').attr('data-checkout-stage-completed');
            var isPickupEnabled = shipment.selectedShippingMethod.pointPickupEnabled;
            if (isPickupEnabled) {
                var pickupChosen = $('.js-shipping-type-' + shipment.selectedShippingMethod.ID).prop('data-pickupchosen') || false;
                $('.js-shipping-types:not(.js-shipping-type-' + shipment.selectedShippingMethod.ID + ')').prop('data-pickupchosen', 'false');
                stepShippingCompleted = $('.shipping-form').attr('data-checkout-stage-completed') == 'true' && pickupChosen;
                stepShippingCompleted = stepShippingCompleted ? 'true' : 'false';
            }
            $('#expressButtonModal').attr('data-modal-stage', 'shipping');
            if (stepShippingCompleted === 'false') {
                $('input[name$=storeId]').remove();
                $('.js-select-store').show();
                $('.shipping-form .js-change-store').hide();
                $('.selectedStoreRecap').hide();
                if (shipment.selectedShippingMethod.pointPickupEnabled) {
                    // Hide default shipping's form when PUP flow is selected. Apply only for UA
                    hideAddressForm('pup');
                    setMandatoryBilling();
                    if ($('.getNovaPoshtaSettlement').length > 0) {
                        hideAddressForm('pup');
                    }
                } else {
                    // Remove previous selection for pickup point
                    $('input[name$=pickUpPointNumber]').remove();
                    $('input[name$=pickUpPointName]').remove();
                    $('input[name$=pickUpPointAddress1]').remove();
                    $('input[name$=pickUpPointCity]').remove();
                    $('input[name$=pickUpPointPostalCode]').remove();
                    $('.selectedExpressOnePickupPointRecap').addClass('hide');
                    $('.js-select-eo-pup').removeClass('hide');
                    $('.selectedPickupRecapBRT').addClass('hide');
                    $('.js-select-pickup-BRT').removeClass('hide');
                    $('.selectedPickupRecapBPOST').addClass('hide');
                    $('.js-select-pickup-BPOST').removeClass('hide');
                    $('.selectedPickupRecapPDB').addClass('hide');
                    $('.js-select-pickup-PDB').removeClass('hide');
                    $('.cc-selectedPickupRecap').addClass('hide');
                    $('.js-select-pickup-EVR').removeClass('hide');
                    $('.js-select-pickup-PTN').removeClass('hide');
                    $('.js-select-pickup-EST').removeClass('hide');
                    $('.js-select-pickup-DEL').removeClass('hide');
                    $('.js-select-pickup-CTT').removeClass('hide');
                    $('.js-select-pickup-GLS').removeClass('hide');
                    $('.js-select-pickup-MRE').removeClass('hide');
                    $('.js-select-pickup-GLSHU').removeClass('hide');
                    $('.selectedPickupRecapHermes').addClass('hide');
                    $('.js-select-pickup-hermes').removeClass('hide');
                    $('.selectedNovaPoshtaPickupRecap').addClass('hide');
                    $('.js-select-pickup-DPD').removeClass('hide');
                    $('.js-select-pickup-FAN').removeClass('hide');
                    $('.js-select-pickup-XBS').removeClass('hide');
                    $('.np-first-selection-btn').removeClass('hide');
                }
                if (shipment.selectedShippingMethod.storePickupEnabled || shipment.selectedShippingMethod.pointPickupEnabled) {
                    $('.selectedPickupRecapBRT').addClass('hide');
                    $('.js-select-pickup-BRT').removeClass('hide');
                    $('.selectedPickupRecapBPOST').addClass('hide');
                    $('.js-select-pickup-BPOST').removeClass('hide');
                    $('.selectedPickupRecapPDB').addClass('hide');
                    $('.js-select-pickup-PDB').removeClass('hide');
                    $('.cc-selectedPickupRecap').addClass('hide');
                    $('.js-select-pickup-EVR').removeClass('hide');
                    $('.js-select-pickup-PTN').removeClass('hide');
                    $('.js-select-pickup-EST').removeClass('hide');
                    $('.js-select-pickup-DEL').removeClass('hide');
                    $('.js-select-pickup-CTT').removeClass('hide');
                    $('.js-select-pickup-GLS').removeClass('hide');
                    $('.js-select-pickup-MRE').removeClass('hide');
                    $('.js-select-pickup-GLSHU').removeClass('hide');
                    $('.selectedPickupRecapHermes').addClass('hide');
                    $('.js-select-pickup-hermes').removeClass('hide');
                    $('.js-select-pickup-DPD').removeClass('hide');
                    $('.js-select-pickup-FAN').removeClass('hide');
                    $('.js-select-pickup-XBS').removeClass('hide');
                    $('.next-step-button').find('.submit-shipping').prop('disabled', true);
                    $('.js-expressButtonContinue').prop('disabled', true);
                } else {
                    $('.next-step-button').find('.submit-shipping').prop('disabled', false);
                    $('.js-expressButtonContinue').prop('disabled', false);
                }
            } else {
                if ($('.data-checkout-stage').data('customer-type') === 'guest' && data.options && data.options.selectMethodStep && $('.isSmartGift').val() === 'false') {
                    clearInputFields();
                }
                if (shipment.selectedShippingMethod.storePickupEnabled) {
                    hideAddressForm('pickup');
                    setMandatoryBilling();
                } else if (shipment.selectedShippingMethod.pointPickupEnabled) {
                    hideAddressForm('pup');
                    setMandatoryBilling();
                } else if (shipment.selectedShippingMethod.isElectronicShipping) {
                    hideAddressFormForGiftcard();
                    setMandatoryBilling();
                } else {
                    showAddressForm();
                    resetBillingState();
                }
            }
            let shippingMethodId = shipment.selectedShippingMethod.ID;
            $('.js-shipping-types').removeClass('shipping-method-selected');
            $('.js-shipping-type-' + shippingMethodId).addClass('shipping-method-selected');
            enableExpressButton(shipment, data);

            let storeName;
            let storeAddress;
            let storeCity;
            let postalCode;
            let selectedStoreSap;
            let type;
            let serviceType;
            if (shipment.selectedShippingMethod.ID === 'CZPP2I' || shipment.selectedShippingMethod.ID === 'PPLPI') {
                storeName = $('.js-pickup-name-PPL').data('info') || null;
                storeAddress = $('.js-pickup-address1-PPL').data('info') || null;
                storeCity = $('.js-pickup-address2-PPL').data('info') || null;
                postalCode = $('.js-pickup-postalcode-PPL').data('info') || null;
                selectedStoreSap = $('.js-pickup-sap-PPL').data('info') || null;

                if (storeName && storeAddress && storeCity && postalCode && selectedStoreSap) {
                    const data = {
                        name: storeName,
                        address1: storeAddress,
                        city: storeCity,
                        postalCode: postalCode,
                        sap: selectedStoreSap
                    };

                    $('body').trigger('PPL:selectedPickup', data);
                }
            }
            if (shipment.selectedShippingMethod.ID === 'DEPP2I') {
                storeName = $('.js-pickup-name-DHL').data('info') || null;
                storeAddress = $('.js-pickup-address1-DHL').data('info') || null;
                storeCity = $('.js-pickup-address2-DHL').data('info') || null;
                postalCode = $('.js-pickup-postalcode-DHL').data('info') || null;
                selectedStoreSap = $('.js-pickup-sap-DHL').data('info') || null;

                if (storeName && storeAddress && storeCity && postalCode && selectedStoreSap) {
                    const data = {
                        name: storeName,
                        address1: storeAddress,
                        city: storeCity,
                        postalCode: postalCode,
                        sap: selectedStoreSap
                    };

                    $('body').trigger('DHL:selectedPickup', data);
                }
            }
            if (shipment.selectedShippingMethod.ID === 'PLPP2I') {
                storeName = $('.js-pickup-name-DPD').data('info') || null;
                storeAddress = $('.js-pickup-address1-DPD').data('info') || null;
                storeCity = $('.js-pickup-address2-DPD').data('info') || null;
                postalCode = $('.js-pickup-postalcode-DPD').data('info') || null;
                selectedStoreSap = $('.js-pickup-sap-DPD').data('info') || null;

                if (storeName && storeAddress && storeCity && postalCode && selectedStoreSap) {
                    const data = {
                        name: storeName,
                        address1: storeAddress,
                        city: storeCity,
                        postalCode: postalCode,
                        sap: selectedStoreSap
                    };

                    $('body').trigger('DPD:selectedPickup', data);
                }
            }
            if (shipment.selectedShippingMethod.ID === 'FRCOLPI' || shipment.selectedShippingMethod.ID === 'COLFRPUPI') {
                storeName = $('.js-pickup-name-CLSS').data('info') || null;
                storeAddress = $('.js-pickup-address1-CLSS').data('info') || null;
                storeCity = $('.js-pickup-address2-CLSS').data('info') || null;
                postalCode = $('.js-pickup-postalcode-CLSS').data('info') || null;
                selectedStoreSap = $('.js-pickup-sap-CLSS').data('info') || null;
                type = $('.js-pickup-type-CLSS').data('info') || null;

                if (storeName && storeAddress && storeCity && postalCode && selectedStoreSap) {
                    const data = {
                        name: storeName,
                        address1: storeAddress,
                        city: storeCity,
                        postalCode: postalCode,
                        sap: selectedStoreSap,
                        type: type
                    };

                    $('body').trigger('CLSS:selectedPickup', data);
                }
            }

            if (shipment.selectedShippingMethod.shippingMethodType === 'PDB') {
                storeName = $('.js-pickup-name-PDB').data('info') || null;
                storeAddress = $('.js-pickup-address1-PDB').data('info') || null;
                storeCity = $('.js-pickup-address2-PDB').data('info') || null;
                postalCode = $('.js-pickup-postalcode-PDB').data('info') || null;
                selectedStoreSap = $('.js-pickup-sap-PDB').data('info') || null;
                type = $('.js-pickup-type-PDB').data('info') || null;
                serviceType = $('.js-pickup-servicetype-PDB').data('info') || null;

                if (storeName && storeAddress && storeCity && postalCode && selectedStoreSap) {
                    const data = {
                        number: selectedStoreSap,
                        name: storeName,
                        address1: storeAddress,
                        city: storeCity,
                        postalCode: postalCode,
                        type: type,
                        serviceType: serviceType // PDB needs serviceType as pickupPointName to close the order
                    };

                    $('body').trigger('PDB:selectedPickup', data);
                }
            }

            if (['BPOST', 'EVR', 'PTN', 'EST', 'DEL', 'GLS', 'MRE', 'GLSHU', 'DPD', 'FAN', 'XBS', 'CTT'].indexOf(shipment.selectedShippingMethod.shippingMethodType) !== -1) {
                var shippingMethodType = shipment.selectedShippingMethod.shippingMethodType;
                storeName = $('.js-pickup-name-' + shippingMethodType).data('info') || null;
                storeAddress = $('.js-pickup-address1-' + shippingMethodType).data('info') || null;
                storeCity = $('.js-pickup-address2-' + shippingMethodType).data('info') || null;
                postalCode = $('.js-pickup-postalcode-' + shippingMethodType).data('info') || null;
                selectedStoreSap = $('.js-pickup-sap-' + shippingMethodType).data('info') || null;
                type = $('.js-pickup-type-' + shippingMethodType).data('info') || null;

                if (storeName && storeAddress && storeCity && postalCode && selectedStoreSap) {
                    const data = {
                        number: selectedStoreSap,
                        name: storeName,
                        address1: storeAddress,
                        city: storeCity,
                        postalCode: postalCode,
                        type: type
                    };

                    $('body').trigger('STANDARD:selectedPickup', data);
                }
            }
            if (shipment.selectedShippingMethod.ID === 'UPSFRPUPI') {
                storeName = $('.selectedPickupPointRecap .js-point-name').html();
                storeAddress = $('.selectedPickupPointRecap .js-point-address1').html();
                storeCity = $('.selectedPickupPointRecap .js-point-city').html();
                postalCode = $('.selectedPickupPointRecap .js-point-postal-code').html();
                selectedStoreSap = $('.js-pickup-type-CLSS').data('info') || null;

                if (storeName && storeAddress && storeCity && postalCode && selectedStoreSap) {
                    const data = {
                        name: storeName,
                        address1: storeAddress,
                        city: storeCity,
                        postalCode: postalCode,
                        sap: selectedStoreSap,
                        type: type
                    };

                    $('body').trigger('pickupPoint:selectedPoint', data);
                }
            }
        });
    },

    proceedToBillingInCaseIsMandatoryForCurrentCountry: function () {
        $(document).on('click', '.js-proceed-to-billing', function () {
            $('.billingFormGroup').removeClass('hide');
            $('.js-proceed-to-billing').addClass('hide');
            $('.next-step-button.shipping').removeClass('hide');
            $('html, body').animate({
                scrollTop: $('.billingFormGroup').offset().top - 75
            }, 1000, 'linear');

            var shippingForm = $('form[name=dwfrm_shipping]');
            var shippingData = {
                firstName: $('input[name$=_firstName]', shippingForm).val(),
                lastName: $('input[name$=_lastName]', shippingForm).val(),
                address1: $('input[name$=_address1]', shippingForm).val(),
                address2: $('input[name$=_address2]', shippingForm).val(),
                city: $('input[name$=_city]', shippingForm).val(),
                postalCode: $('input[name$=_postalCode]', shippingForm).val(),
                stateCode: $('select[name$=_stateCode],input[name$=_stateCode]', shippingForm).val(),
                countryCode: $('select[name$=_country]', shippingForm).val()
            };
            $('input[name$=_billing_addressFields_firstName]').val(shippingData.firstName);
            $('input[name$=_billing_addressFields_lastName]').val(shippingData.lastName);
            $('input[name$=_billing_addressFields_address1]').val(shippingData.address1);
            $('input[name$=_billing_addressFields_address2]').val(shippingData.address2);
            $('input[name$=_billing_addressFields_city]').val(shippingData.city);
            $('input[name$=_billing_addressFields_postalCode]').val(shippingData.postalCode);
            $('select[name$=_billing_addressFields_states_stateCode],input[name$=_billing_addressFields_stateCode]')
                .val(shippingData.stateCode)
                .trigger('chosen:updated');
            $('select[name$=_billing_addressFields_country]').val(shippingData.countryCode).trigger('chosen:updated');
        });
    },

    selectShippingMethod: function () {
        $(document).on('click', '.js-shipping-types', function () {
            if (!$(this).hasClass('shipping-method-selected') && !$(this).hasClass('js-shipping-types-express')) {
                var $shippingForm = $(this).parents('form');
                var methodID = $(this).find('.js-shipping-method').val();
                $('.error-message.generic').hide();
                $('.error-message.generic-express').hide();
                $(this).find('.js-shipping-method').prop('checked', true);
                var shipmentUUID = $shippingForm.find('[name=shipmentUUID]').val();
                var urlParams = addressHelpers.methods.getAddressFieldsFromUI($shippingForm);
                urlParams.shipmentUUID = shipmentUUID;
                urlParams.methodID = methodID;
                urlParams.isGift = ($('[name^=wrapquantity]').val() > 0).toString() || false;
                urlParams.giftMessage = $('.js-gift-message').val();

                var url = $(this).closest('.shipping-method-list').data('select-shipping-method-url');
                selectShippingMethodAjax(url, urlParams);
            }
        });
    },

    selectMultiShipping: function () {
        $('input[name="usingMultiShipping"]').on('change', function () {
            var checked = this.checked;
            toggleMultiShip(checked);
        });
    },

    selectSingleShipAddress: function () {
        $('.single-shipping .addressSelector input').on('change', function () {
            const form = $(this).parents('form')[0];
            const $selectedOption = $(this);
            const attrs = $selectedOption.data();
            const shipmentUUID = $selectedOption[0].value;
            const originalUUID = $('input[name=shipmentUUID]', form).val();

            Object.keys(attrs).forEach(function (attr) {
                let element = attr === 'countryCode' ? 'country' : attr;
                $('.shipping-address [name$=' + element + ']', form).val(attrs[attr]);
            });
            $('.shipping-address [name$=stateCode]', form).trigger('change').trigger('chosen:updated');

            $(form).attr('data-address-mode', 'details');

            if (shipmentUUID === 'new') {
                $(form).attr('data-address-mode', 'new');
                $('.shipping-address-block').addClass('hidden');
                $(this).closest('.internal-container').append($('.shipping-address-block').removeClass('hidden'));
            } else if (shipmentUUID === originalUUID) {
                $(form).attr('data-address-mode', 'shipment');
            } else if (shipmentUUID.indexOf('ab_') === 0) {
                $(form).attr('data-address-mode', 'edit');
            } else {
                $(form).attr('data-address-mode', 'edit');
            }
            // without this, HK users won't be able to add a ne address at checkout
            // the zipcode field will be empty and not editable
            if ($('.shippingZipCode').attr('value') !== '' && $('.shippingZipCode').val() === '') {
                $('.shippingZipCode').val($('.shippingZipCode').attr('value'));
            }
        });
    },

    selectMultiShipAddress: function () {
        $('.product-shipping-block .addressSelector').on('change', function () {
            var form = $(this).parents('form')[0];
            var selectedOption = $('option:selected', this);
            var attrs = selectedOption.data();
            var shipmentUUID = selectedOption[0].value;
            var originalUUID = $('input[name=shipmentUUID]', form).val();
            var pliUUID = $('input[name=productLineItemUUID]', form).val();

            Object.keys(attrs).forEach(function (attr) {
                $('[name$=' + attr + ']', form).val(attrs[attr]);
            });

            if (shipmentUUID === 'new' && pliUUID) {
                var createShipmentUrl = $(this).attr('data-create-shipment-url');
                createNewShipment(createShipmentUrl, { productLineItemUUID: pliUUID })
                    .done(function (response) {
                        $.spinner().stop();
                        if (response.error) {
                            if (response.redirectUrl) {
                                window.location.href = response.redirectUrl;
                            }
                            return;
                        }

                        $('body').trigger('checkout:updateCheckoutView',
                            {
                                order: response.order,
                                customer: response.customer,
                                options: { keepOpen: true }
                            }
                        );

                        $(form).attr('data-address-mode', 'new');
                    })
                    .fail(function () {
                        $.spinner().stop();
                    });
            } else if (shipmentUUID === originalUUID) {
                $('select[name$=stateCode]', form).trigger('change');
                $(form).attr('data-address-mode', 'shipment');
            } else if (shipmentUUID.indexOf('ab_') === 0) {
                var url = form.action;
                var serializedData = $(form).serialize();
                createNewShipment(url, serializedData)
                    .done(function (response) {
                        $.spinner().stop();
                        if (response.error) {
                            if (response.redirectUrl) {
                                window.location.href = response.redirectUrl;
                            }
                            return;
                        }

                        $('body').trigger('checkout:updateCheckoutView',
                            {
                                order: response.order,
                                customer: response.customer,
                                options: { keepOpen: true }
                            }
                        );

                        $(form).attr('data-address-mode', 'customer');
                    })
                    .fail(function () {
                        $.spinner().stop();
                    });
            } else {
                var updatePLIShipmentUrl = $(form).attr('action');
                var serializedAddress = $(form).serialize();
                createNewShipment(updatePLIShipmentUrl, serializedAddress)
                    .done(function (response) {
                        $.spinner().stop();
                        if (response.error) {
                            if (response.redirectUrl) {
                                window.location.href = response.redirectUrl;
                            }
                            return;
                        }

                        $('body').trigger('checkout:updateCheckoutView',
                            {
                                order: response.order,
                                customer: response.customer,
                                options: { keepOpen: true }
                            }
                        );

                        $(form).attr('data-address-mode', 'edit');
                    })
                    .fail(function () {
                        $.spinner().stop();
                    });
            }
        });
    },

    selectCityForAreas: function () {
        $(document).ready(loadAreas());
        $(document).ready(loadBillingAreas());

        $('body').on('change', 'select.trShippingState', function () {
            loadAreas($(this));
        });

        $('body').on('change', 'select.trBillingState', function () {
            var selectedCityId = $(this).find('option:selected').attr('id');
            var url = $(this).data('url');

            if (!url) {
                return;
            }

            $.spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                data: {selectedCityId: selectedCityId},
                success: data => {
                    // Delete all options
                    $('select.trBillingAddressCity').html('');
                    if (data.html) {
                        // Add the possible options
                        $('select.trBillingAddressCity').html(data.html);
                    }
                    // Refresh the dropdown
                    $('select.trBillingAddressCity').trigger('chosen:updated');
                    $.spinner().stop();
                },
                error: function (err) {
                    console.log(err);
                    // Delete all options
                    $('select.trBillingAddressCity').html('');
                    // Refresh the dropdown
                    $('select.trBillingAddressCity').trigger('chosen:updated');
                    $.spinner().stop();
                }
            });
        });

        $('body').on('address:addressSelector', (e, d) => {
            // $('select.trShippingState option').removeAttr('selected');
            var selectedAreaValue = $(d).data('city') || '';
            var selectedCityId = $(d).data('state-code') || '';
            if (selectedCityId && selectedAreaValue) {
                loadAreas(null, selectedCityId, selectedAreaValue);
                // Update the city and area selected
                $('select.trShippingState option').removeAttr('selected');
                $('select.trShippingAddressCity option').removeAttr('selected');
                $("select.trShippingState option[id='" + selectedCityId + "'").attr('selected', 'selected');
                $("select.trShippingAddressCity option[value='" + selectedAreaValue + "'").attr('selected', 'selected');
                $('select.trShippingState').trigger('chosen:updated');
                $('select.trShippingAddressCity').trigger('chosen:updated');
            }
        });

        function loadAreas (element = null, selectedCityId = null, selectedAreaValue = null) {
            element = element || $('select.trShippingState');

            if (!element || element.length < 1) {
                return;
            }

            var url = element.data('url');

            if (!url) {
                return;
            }

            if (!selectedCityId) {
                selectedCityId = element.find('option:selected').attr('id');
            }

            // Address selection in checkout
            if (!selectedAreaValue) {
                var inputAddressSelectorChecked = $("input[name='addressSelector']:checked");
                selectedAreaValue = inputAddressSelectorChecked.length > 0 ? $(inputAddressSelectorChecked).data('city') : null;
            }

            // Edit Address in My Account
            if (!selectedAreaValue) {
                var divTRaddress = $('#rawTRAddress');
                if (divTRaddress && divTRaddress.length > 0) {
                    selectedAreaValue = $(divTRaddress).data('city') ? $(divTRaddress).data('city') : null;
                }
            }

            $.spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                data: {selectedCityId: selectedCityId, selectedAreaValue: selectedAreaValue},
                success: data => {
                    // Delete all options
                    $('select.trShippingAddressCity').html('');
                    if (data.html) {
                        // Add the possible options
                        $('select.trShippingAddressCity').html(data.html);
                        if ($('select.trBillingAddressCity').val() === '') {
                            $('select.trBillingAddressCity').html(data.html);
                            // Refresh the dropdown
                            $('select.trBillingAddressCity').trigger('chosen:updated');
                        }
                    }
                    // Refresh the dropdown
                    $('select.trShippingAddressCity').trigger('chosen:updated');
                    $.spinner().stop();
                },
                error: function (err) {
                    console.log(err);
                    // Delete all options
                    $('select.trShippingAddressCity').html('');
                    // Refresh the dropdown
                    $('select.trShippingAddressCity').trigger('chosen:updated');
                    $.spinner().stop();
                }
            });
        };

        function loadBillingAreas (element = null, selectedCityId = null, selectedAreaValue = null) {
            element = element || $('select.trBillingState');

            if (!element || element.length < 1) {
                return;
            }

            var url = element.data('url');

            if (!url) {
                return;
            }

            if (!selectedCityId) {
                selectedCityId = element.find('option:selected').attr('id');
            }

            // Address selection in checkout - For Billing
            if (!selectedAreaValue) {
                selectedAreaValue = $('select.trBillingAddressCity').length > 0 && $('select.trBillingAddressCity').attr('value') ? $('select.trBillingAddressCity').attr('value') : null;
            }

            // Edit Address in My Account
            /*
            if (!selectedAreaValue) {
                var divTRaddress = $('#rawTRAddress');
                if (divTRaddress && divTRaddress.length > 0) {
                    selectedAreaValue = $(divTRaddress).data('city') ? $(divTRaddress).data('city') : null;
                }
            }
            */

            $.spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                data: {selectedCityId: selectedCityId, selectedAreaValue: selectedAreaValue},
                success: data => {
                    // Delete all options
                    $('select.trBillingAddressCity').html('');
                    if (data.html) {
                        // Add the possible options
                        $('select.trBillingAddressCity').html(data.html);
                    }
                    // Refresh the dropdown
                    $('select.trBillingAddressCity').trigger('chosen:updated');
                    $.spinner().stop();
                },
                error: function (err) {
                    console.log(err);
                    // Delete all options
                    $('select.trBillingAddressCity').html('');
                    // Refresh the dropdown
                    $('select.trBillingAddressCity').trigger('chosen:updated');
                    $.spinner().stop();
                }
            });
        };
    },

    // Select city based on input zip code
    selectCityByZipCode: function () {
        $('.grZipCode').on('input', function () {
            updateStateSelectMenu();
        });

        $('.grShippingZipCode').on('input', function () {
            updateStateSelectMenu('shipping');
        });

        $('body').on('input', '.grBillingZipCode', function (e) {
            updateStateSelectMenu('billing');
        });

        function updateStateSelectMenu (section = '') {
            var section = section.charAt(0).toUpperCase() + section.slice(1);
            var currentZipCode = $('.gr' + section + 'ZipCode').val();
            var zipCodeFormat = /^\d{3}\s?\d{2}$/; // Zip code format must be 5 characters long with an optional space (123 45 or 12345)

            if (zipCodeFormat.test(currentZipCode)) {
                var url = $('.gr' + section + 'ZipCode').data('url');

                $.spinner().start();
                $.ajax({
                    url: url,
                    method: 'GET',
                    data: {
                        selectMenu: '.gr' + section + 'State',
                        zipCode: currentZipCode
                    },
                    success: function (data) {
                        if (data.stateSFID) {
                            $(data.selectMenu).val(data.stateSFID).trigger('chosen:updated');
                        }
                    }
                }).then(function () {
                    $.spinner().stop();
                });
            }
        }
    },

    changeCountry: function () {
        $('body').on('change', 'select.shippingCountry', function (e) {
            e.preventDefault();
            var url = $(e.currentTarget).data('url');
            var selectedCountryId = $(this).find('option:selected').attr('value');
            if (!selectedCountryId) {
                return;
            }
            let currentCountryShipping = $('.currentCountryShipping').val();
            $('body').trigger('checkout:changeCountry', {
                previousCountry: currentCountryShipping,
                newCountry: selectedCountryId
            });
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'get',
                data: {selectedCountryId: selectedCountryId},
                success: data => {
                    if (data) {
                        $('.changeCountryModalContainer').html(data);

                        const onClose = () => {
                            $('select.shippingCountry').val(currentCountryShipping).trigger('chosen:updated');
                            $('body').trigger('checkout:changeCountry', {
                                action: 'back_to_the_website',
                                previousCountry: currentCountryShipping,
                                newCountry: selectedCountryId
                            });
                        };

                        const htmlContent = $('#changeCountryModal').html();
                        // create and open confirmation modal
                        const modal = newModalFromString(htmlContent, false, [], null, onClose);
                        $(modal.modalBox).addClass('change-country-modal');
                        modal.open();

                        $(modal.modalBox).on('click', '.close, .change-country-return-btn', function () {
                            $('body').trigger('checkout:changeCountry', {
                                action: 'back_to_the_website',
                                previousCountry: currentCountryShipping,
                                newCountry: selectedCountryId
                            });
                            $('select.shippingCountry').val(currentCountryShipping).trigger('chosen:updated');
                            modal.close();
                            modal.destroy();
                        });
                        $(modal.modalBox).on('click', '.change-country-confirmation-btn', function () {
                            $('body').trigger('checkout:changeCountry', {
                                action: 'proceed',
                                previousCountry: currentCountryShipping,
                                newCountry: selectedCountryId
                            });
                        });
                        $.spinner().stop();
                    }
                },
                error: function () {
                    $('select.shippingCountry').val(currentCountryShipping).trigger('chosen:updated');
                    $.spinner().stop();
                }
            });
        });
    },

    emailDomainValidation: function () {
        EmailDomainValidation.run('#shippingEmail', '.unknown-email-domain');
    }
};
